const OmHero = () => {
  return <section className="relative isolate overflow-hidden bg-white py-20 sm:py-24 lg:py-40 xl:py-56">
            <img
    src="/images/OM Edited/DSC02396.webp"
    alt="Hintergrundbild des Ayurveda-Resorts Hiru Om"
    className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="eager" fetchPriority="high" />

            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/70" />

            <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto flex min-h-[360px] max-w-5xl items-center justify-center sm:min-h-[420px] lg:min-h-[520px]">
                    <div className="relative w-full max-w-4xl p-4 text-center text-white sm:p-6 lg:px-10 lg:py-8">
                        <div className="absolute left-8 top-10 hidden lg:block">
                            <svg width="289" height="245" viewBox="0 0 289 245" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M289 1H1V244.5" stroke="white" strokeWidth="2" />
                            </svg>
                        </div>

                        <div className="absolute -bottom-12 right-8 hidden lg:block">
                            <svg width="289" height="244" viewBox="0 0 289 244" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M0 243.5H288V0" stroke="white" strokeWidth="2" />
                            </svg>
                        </div>

                        <div className="mx-auto mb-6 h-1.5 w-20 rounded-full bg-gradient-to-r from-[#F28600] to-[#ffb347]" />

                        <p className="font-mulish text-sm font-semibold uppercase tracking-[0.35em] text-amber-100 sm:text-base">
                            HIRU OM AYURVEDA RESORT
                        </p>

                        <h1 className="mt-5 font-serif text-4xl font-light leading-tight tracking-tight sm:text-5xl lg:text-6xl">
                            Hiru Om
                            <br />
                            Ayurveda Resort
                        </h1>
                    </div>
                </div>
            </div>
        </section>;
};
export default OmHero;
